export default {
  oakhouse: '#f9504c',
};
